module.exports = __webpack_public_path__ + "img/folder-minus.3ed1e96e.svg";